module.exports = __webpack_public_path__ + "static/img/female-bg-id.98c17561.png";